import { Avatar, type AvatarProps } from '@mantine/core';
import { IconBuilding } from '@tabler/icons-react';
import type { ReactNode } from 'react';

/** Company mark: the uploaded logo when there is one, otherwise the first letter / fallback. */
export function OrgLogo({ src, fallback, children, size = 36, ...props }: Omit<AvatarProps, 'src'> & { src?: string | null; fallback?: ReactNode; children?: ReactNode }) {
  if (src) return <Avatar src={src} size={size} radius="md" {...props} styles={{ image: { objectFit: 'contain' } }} style={{ border: '1px solid var(--pf-line)', background: '#fff' }} />;
  return (
    <Avatar size={size} radius="md" color="ink" variant="light" {...props}>
      {children ?? fallback ?? <IconBuilding size={18} stroke={1.6} />}
    </Avatar>
  );
}
